<script>
  import { onMount } from "svelte";
  import P5Background from "./components/App/P5Background.svelte";
  import { marked } from "marked";

  let content = "";
  let container;
  let clickCount = 0; // Counter for the number of clicks/taps

  // Function to hide the container after 5 clicks/taps
  const handleClick = () => {
    clickCount += 1;

    if (clickCount >= 15) {
      container.style.display = "none"; // Hide the container after 5 clicks
    }
  };

  // Fetch and parse the markdown file
  onMount(async () => {
    const response = await fetch("/content.md"); // Adjust the path as needed
    const markdown = await response.text();
    content = marked(markdown);
  });
</script>

<P5Background />

<main>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="content" bind:this={container} on:click={handleClick}>
    <div class="markdown">{@html content}</div>
    <div class="social-links">
      <div class="social-link">
        <a href="https://discord.gg/hX7ZhYA8rS" target="_blank">
          <img src="discord.svg" alt="Discord" />
        </a>
      </div>
      <div class="social-link">
        <a href="https://twitch.tv/midwestfreeks" target="_blank">
          <img src="twitch.svg" alt="Twitch" />
        </a>
      </div>
      <div class="social-link">
        <a href="https://youtube.com/@midwestfreeks" target="_blank">
          <img src="youtube.svg" alt="YouTube" />
        </a>
      </div>
    </div>
    <div>
      <img src="logo.png" alt="Midwest Freeks" class="footer-img" />
    </div>
  </div>
</main>

<style>
  main {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    margin: 0;
    padding: 0;
  }

  .footer-img {
    margin: 40px 0 0;
    stroke: 1px solid #222;
  }

  .content {
    text-align: center;
    padding: 2em;
    margin: 25px 32px;
    background-color: rgba(24, 24, 24, 0.808);
    border-radius: 5px;
    backdrop-filter: blur(15px);
    box-shadow: 4px 4px 4px 3px rgba(0, 0, 0, 0.35);
    color: white;
    max-width: 800px;
  }

  .social-links {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 50px;
  }
  .social-link {
    text-align: center;
  }
  .social-link img {
    width: 50px;
    height: 50px;
  }
  .social-link a {
    display: block;
    color: white;
    text-decoration: none;
    margin-top: 5px;
  }
  .social-link img:hover {
    filter: brightness(0.4);
    filter: drop-shadow(-8px 10px #222);
  }
  @media (max-width: 640px) {
    .content {
      padding: 1.5em;
      max-width: 90%;
    }
  }
</style>
